module.exports = __webpack_public_path__ + "img/Frame 25.d4911bd4.png";